import React, { useState, useEffect } from "react";
import MDMIcon from "../assets/img/mdm_icon_blue.png";
import spareSearchIcon from "../assets/img/spare_search_icon_blue.png";
import modelSearchIcon from "../assets/img/model_search_icon_blue.png";
import technicalDocumentIcon from "../assets/img/techinal_document_icon_blue.png";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import userManagementIcon from "../assets/img/user_document_icon_blue.png";
import serviceAdvisoryIcon from "../assets/img/service_advisory_icon_blue.png";
import useGlobalState from "../Context";
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { useLoading } from "../common/LoadingContext";
import { useNotificationContext } from "../common/NotificationContext";
import download from "downloadjs";
import { DownloadPortalGuideService } from "../services/PortalGuideService";
import { GenerateTokenNonRilService } from "../services/LoginService";
import NoEncryptionGmailerrorredIcon from '@mui/icons-material/NoEncryptionGmailerrorred';
import HubIcon from '@mui/icons-material/Hub';
import {
  Drawer,
  Box,
  ListItemText,
  ListItemIcon,
  ListItem,
  ListItemButton,
  List,
  Typography,
} from "@mui/material";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import { useLocation, useNavigate } from "react-router-dom";
import DehazeIcon from "@mui/icons-material/Dehaze";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneIcon from "@mui/icons-material/Phone";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import PeopleIcon from "@mui/icons-material/People";
import CategoryIcon from "@mui/icons-material/Category";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";
import UploadIcon from "@mui/icons-material/Upload";

const SideNav = ({ toggleSideNavbar }) => {
  const [activeURL, setActiveURL] = useState("/site-master");
  const { pathname } = useLocation();
  const [mdmDropDown, setMdmDropDown] = useState(false);
  const [userDropDown, setUserDropDown] = useState(false);
  const [userAccess, setUserAccess] = useState(false);
  const [spareAccess, setSpareAccess] = useState(false);
  const [techDocAccess, setTechDocAccess] = useState(false);
  const [advisoryAccess, setAdvisoryAccess] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [
    {
      auth,
      isAllNotificateionRead,
      spareAccessRights,
      technicalDocAccessRights,
      advisoriesAccessRights,
    },
  ] = useGlobalState();
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
 

  const userInformation = auth.ldapParam;
  const loginUserType = auth?.ldapParam?.userType;
  const [notificationStatus, setNotificationStatus] = useState(
    isAllNotificateionRead
  );

  useEffect(() => {
      if (loginUserType === "Normal User" || loginUserType === "Domain Admin") {
      if (isAllNotificateionRead && spareAccessRights.read) {
        setSpareAccess(true);
      } else {
        setSpareAccess(false);
      }
      if (isAllNotificateionRead && technicalDocAccessRights.read) {
        setTechDocAccess(true);
      } else {
        setTechDocAccess(false);
      }
      if (isAllNotificateionRead && advisoriesAccessRights.read) {
        setAdvisoryAccess(true);
      } else {
        setAdvisoryAccess(false);
      }
      if (isAllNotificateionRead) {
        setUserAccess(true);
      } else {
        setUserAccess(false);
      }
    } else if (loginUserType === "Main Admin") {
      setSpareAccess(true);
      setTechDocAccess(true);
      setAdvisoryAccess(true);
      setUserAccess(true);
    }
  }, [isAllNotificateionRead]);

  useEffect(() => {
    setActiveURL(pathname);
  }, [pathname]);

  const onClickRout = (rout) => {
    setActiveURL(rout);
    navigate(rout);
  };
  const handleClick = () => {
    setMdmDropDown(!mdmDropDown);
    setUserDropDown(false);
  };

  const handleUserClick = () => {
    setUserDropDown(!userDropDown);
    setMdmDropDown(false);
  };
  const drawerWidth = 220;
  const onForgotPasswordClick = async () => {
    try {
      const param = {
        username: localStorage.getItem("email"),
      };
      setLoading(true);
      const response = await GenerateTokenNonRilService(param);
      if (response) {
        setTokenInSessionStorage(response);
         }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch details");
    } finally {
      setLoading(false);
    }
  };
  const setTokenInSessionStorage = (data) => {
    const details = {
      tempPassword: window.btoa(data?.tempToken),
      currentUserId: data?.userId,
    };
    sessionStorage.setItem("token&userId", JSON.stringify(details));
  };

  return (
    <div>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            border: "none",
          },
        }}
        variant="permanent"
        anchor="left">
        <Box className="sidePanel" role="presentation">
          <Box
            sx={{
              p: 1,
              backgroundColor: "#567aac",
              width: "95%",
              margin: "auto",
              borderRadius: "0px 0px 30px 30px",
            }}>
            
            <Box sx={{ mb: 1, height: 60 }}>
                <Typography
                  sx={{ color: "white", fontSize: "13px" }}
                  variant="h6">
                  {" "}
                  {userInformation.name}
                </Typography>
                <Typography
                  sx={{ color: "white", fontSize: "11px" }}
                  variant="subtitle2">
                  {" "}
                  <PhoneIcon sx={{ fontSize: "12px" }} />{" "}
                  {userInformation.mobile}
                </Typography>

                <Typography
                  sx={{
                    color: "white",
                    fontSize: "11px",
                    display: "inline-flex",
                  }}
                  variant="subtitle2">
                  {" "}
                  <EmailOutlinedIcon
                    sx={{ fontSize: "14px", marginRight: "1px" }}
                  />{" "}
                  {userInformation.username}
                </Typography>
              </Box>
          </Box>
          <Box
            onClick={() => toggleSideNavbar(false)}
            onKeyDown={() => toggleSideNavbar(false)}
            sx={{ flexGrow: 1, backgroundColor: "#ffffff" }}>
            <List sx={{ mt: 0 }}>
              {/* {spareAccessRights.read ? ( */}
              {spareAccess ? (
                <ListItem disablePadding>
                  <ListItemButton
                    selected={activeURL === "/model-search" ? true : false}
                    className={
                      activeURL === "/model-search" ? "active" : "navItem"
                    }
                    onClick={() => {
                      onClickRout("/model-search");
                      setMdmDropDown(false);
                      setUserDropDown(false);
                    }}>
                    <ListItemIcon sx={{ minWidth: "30px" }}>
                      <img src={modelSearchIcon} alt="modelSearchIcon" />
                    </ListItemIcon>
                    <ListItemText
                      className="sideNavList"
                      primary="Model Search"
                    />
                  </ListItemButton>
                </ListItem>
              ) : null}
              {spareAccess ? (
                <ListItem disablePadding>
                  <ListItemButton
                    selected={activeURL === "/spare-search" ? true : false}
                    className={
                      activeURL === "/spare-search" ? "active" : "navItem"
                    }
                    onClick={() => {
                      onClickRout("/spare-search");
                      setMdmDropDown(false);
                      setUserDropDown(false);
                    }}>
                    <ListItemIcon sx={{ minWidth: "30px" }}>
                      <img src={spareSearchIcon} alt="modelSearchIcon" />
                    </ListItemIcon>
                    <ListItemText
                      className="sideNavList"
                      primary="Spare Search"
                    />
                  </ListItemButton>
                </ListItem>
              ) : null}

              {loginUserType === "Main Admin" ||
              (loginUserType === "Domain Admin" && isAllNotificateionRead) ? (
                <ListItem sx={{ display: "block" }} disablePadding>
                  <ListItemButton
                    className={userDropDown ? "active" : "navItem"}
                    onClick={handleUserClick}>
                    <ListItemIcon sx={{ minWidth: "30px" }}>
                      <img src={userManagementIcon} alt="mdm Icon" />
                    </ListItemIcon>
                    <ListItemText
                      className="sideNavList"
                      primary="User Management"
                    />
                    {userDropDown ? (
                      <ListItemIcon sx={{ minWidth: "30px" }}>
                        <ArrowDropUpIcon
                          fontSize="medium"
                          sx={{ color: "#003f93" }}
                        />
                      </ListItemIcon>
                    ) : (
                      <ListItemIcon sx={{ minWidth: "30px" }}>
                        <ArrowDropDownIcon
                          fontSize="medium"
                          sx={{ color: "#003f93" }}
                        />
                      </ListItemIcon>
                    )}
                  </ListItemButton>
                  {userDropDown ? (
                    <List sx={{ pl: 1, margin: 0, pt: 0 }}>
                      <ListItem disablePadding>
                        <ListItemButton
                          selected={
                            activeURL === "/user/user-list" ? true : false
                          }
                          className={
                            activeURL === "/user/user-List"
                              ? "active"
                              : "navItem"
                          }
                          onClick={() => onClickRout("/user/user-list")}>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <CategoryIcon
                              fontSize="medium"
                              sx={{ color: "#003f93" }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            className="sideNavList"
                            primary="Users Detail"
                          />
                        </ListItemButton>
                      </ListItem>
                      <ListItem disablePadding>
                        <ListItemButton
                          selected={
                            activeURL === "/user/accessRights" ? true : false
                          }
                          className={
                            activeURL === "/user/accessRights"
                              ? "active"
                              : "navItem"
                          }
                          onClick={() => onClickRout("/user/accessRights")}>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <PeopleIcon
                              fontSize="medium"
                              sx={{ color: "#003f93" }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            className="sideNavList"
                            primary="Access Rights"
                          />
                        </ListItemButton>
                      </ListItem>
                      <ListItem disablePadding>
                        <ListItemButton
                          selected={
                            activeURL === "/user/departments" ? true : false
                          }
                          className={
                            activeURL === "/user/departments"
                              ? "active"
                              : "navItem"
                          }
                          onClick={() => onClickRout("/user/departments")}>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <GroupWorkIcon
                              fontSize="medium"
                              sx={{ color: "#003f93" }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            className="sideNavList"
                            primary="Department"
                          />
                        </ListItemButton>
                      </ListItem>
                      <ListItem disablePadding>
                        <ListItemButton
                          selected={
                            activeURL === "/user/function" ? true : false
                          }
                          className={
                            activeURL === "/user/function"
                              ? "active"
                              : "navItem"
                          }
                          onClick={() => onClickRout("/user/function")}>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <HubIcon
                              fontSize="medium"
                              sx={{ color: "#003f93" }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            className="sideNavList"
                            primary="Function"
                          />
                        </ListItemButton>
                      </ListItem>
                    </List>
                  ) : (
                    ""
                  )}
                </ListItem>
              ) : null}
              {loginUserType === "Main Admin" ||
              (loginUserType === "Domain Admin" && isAllNotificateionRead) ? (
                <ListItem sx={{ display: "block" }} disablePadding>
                  <ListItemButton
                    className={mdmDropDown ? "active" : "navItem"}
                    onClick={handleClick}>
                    <ListItemIcon sx={{ minWidth: "30px" }}>
                      <img src={MDMIcon} alt="mdm Icon" />
                    </ListItemIcon>
                    <ListItemText
                      className="sideNavList"
                      primary="Master Data Managament"
                    />
                    {mdmDropDown ? (
                      <ListItemIcon sx={{ minWidth: "30px" }}>
                        <ArrowDropUpIcon
                          fontSize="medium"
                          sx={{ color: "#003f93" }}
                        />
                      </ListItemIcon>
                    ) : (
                      <ListItemIcon sx={{ minWidth: "30px" }}>
                        <ArrowDropDownIcon
                          fontSize="medium"
                          sx={{ color: "#003f93" }}
                        />
                      </ListItemIcon>
                    )}
                  </ListItemButton>
                  {mdmDropDown ? (
                    <List sx={{ pl: 1, margin: 0, pt: 0 }}>
                      <ListItem disablePadding>
                        <ListItemButton
                          selected={
                            activeURL === "/Master_Service/category-list"
                              ? true
                              : false
                          }
                          className={
                            activeURL === "/Master_Service/category-List"
                              ? "active"
                              : "navItem"
                          }
                          onClick={() =>
                            onClickRout("/Master_Service/category-list")
                          }>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <CategoryIcon
                              fontSize="medium"
                              sx={{ color: "#003f93" }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            className="sideNavList"
                            primary="Category"
                          />
                        </ListItemButton>
                      </ListItem>
                      <ListItem disablePadding>
                        <ListItemButton
                          selected={
                            activeURL === "/Master_Service/family-list"
                              ? true
                              : false
                          }
                          className={
                            activeURL === "/Master_Service/family-List"
                              ? "active"
                              : "navItem"
                          }
                          onClick={() =>
                            onClickRout("/Master_Service/family-list")
                          }>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <PeopleIcon
                              fontSize="medium"
                              sx={{ color: "#003f93" }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            className="sideNavList"
                            primary="Family"
                          />
                        </ListItemButton>
                      </ListItem>
                      <ListItem disablePadding>
                        <ListItemButton
                          selected={
                            activeURL === "/Master_Service/brick-list"
                              ? true
                              : false
                          }
                          className={
                            activeURL === "/Master_Service/brick-list"
                              ? "active"
                              : "navItem"
                          }
                          onClick={() =>
                            onClickRout("/Master_Service/brick-list")
                          }>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <DehazeIcon
                              fontSize="medium"
                              sx={{ color: "#003f93" }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            className="sideNavList"
                            primary="Brick"
                          />
                        </ListItemButton>
                      </ListItem>
                      <ListItem disablePadding>
                        <ListItemButton
                          selected={
                            activeURL === "/Master_Service/brand-list"
                              ? true
                              : false
                          }
                          className={
                            activeURL === "/Master_Service/brand-List"
                              ? "active"
                              : "navItem"
                          }
                          onClick={() =>
                            onClickRout("/Master_Service/brand-list")
                          }>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <LabelImportantIcon
                              fontSize="medium"
                              sx={{ color: "#003f93" }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            className="sideNavList"
                            primary="Brand"
                          />
                        </ListItemButton>
                      </ListItem>
                      <ListItem disablePadding>
                        <ListItemButton
                          selected={
                            activeURL === "/Master_Service/vendor-list"
                              ? true
                              : false
                          }
                          className={
                            activeURL === "/Master_Service/vendor-list"
                              ? "active"
                              : "navItem"
                          }
                          onClick={() =>
                            onClickRout("/Master_Service/vendor-list")
                          }>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <SupervisedUserCircleIcon
                              fontSize="medium"
                              sx={{ color: "#003f93" }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            className="sideNavList"
                            primary="Vendor"
                          />
                        </ListItemButton>
                      </ListItem>
                      <ListItem disablePadding>
                        <ListItemButton
                          selected={
                            activeURL === "/Master_Service/partType-list"
                              ? true
                              : false
                          }
                          className={
                            activeURL === "/Master_Service/partType-list"
                              ? "active"
                              : "navItem"
                          }
                          onClick={() =>
                            onClickRout("/Master_Service/partType-list")
                          }>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <BuildCircleIcon
                              fontSize="medium"
                              sx={{ color: "#003f93" }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            className="sideNavList"
                            primary="Part Type"
                          />
                        </ListItemButton>
                      </ListItem>
                    </List>
                  ) : (
                    ""
                  )}
                </ListItem>
              ) : null}
              {/* {technicalDocAccessRights.read ? ( */}
              {techDocAccess ? (
                <ListItem disablePadding>
                  <ListItemButton
                    selected={
                      activeURL === "/technical-document" ? true : false
                    }
                    className={
                      activeURL === "/technical-document" ? "active" : "navItem"
                    }
                    onClick={() => {
                      onClickRout("/technical-document");
                      setMdmDropDown(false);
                      setUserDropDown(false);
                    }}>
                    <ListItemIcon sx={{ minWidth: "30px" }}>
                      <img
                        src={technicalDocumentIcon}
                        alt="technical document Icon"
                      />
                    </ListItemIcon>
                    <ListItemText
                      className="sideNavList"
                      primary="Technical Document"
                    />
                  </ListItemButton>
                </ListItem>
              ) : null}

              {/* {advisoriesAccessRights.read ? ( */}
              {advisoryAccess ? (
                <ListItem disablePadding>
                  <ListItemButton
                    selected={activeURL === "/Service-Advisory" ? true : false}
                    className={
                      activeURL === "/Service-Advisory" ? "active" : "navItem"
                    }
                    onClick={() => {
                      onClickRout("/Service-Advisory");
                      setMdmDropDown(false);
                    }}>
                    <ListItemIcon sx={{ minWidth: "30px" }}>
                      <img
                        src={serviceAdvisoryIcon}
                        alt="service advisory Icon"
                      />
                    </ListItemIcon>
                    <ListItemText
                      className="sideNavList"
                      primary="Service Advisory"
                    />
                  </ListItemButton>
                </ListItem>
              ) : null}

              
              {loginUserType === "Main Admin" ||
              (loginUserType === "Domain Admin" && isAllNotificateionRead) ? (
                <ListItem disablePadding>
                  <ListItemButton
                    selected={activeURL === "/bulk-upload" ? true : false}
                    className={
                      activeURL === "/bulk-upload" ? "active" : "navItem"
                    }
                    onClick={() => {
                      onClickRout("/bulk-upload");
                      setMdmDropDown(false);
                    }}>
                    <ListItemIcon sx={{ minWidth: "30px" }}>
                      <UploadIcon sx={{ color: "#003f93" }} />
                    </ListItemIcon>
                    <ListItemText
                      className="sideNavList"
                      primary="Bulk Upload"
                    />
                  </ListItemButton>
                </ListItem>
              ) : null}
             
               <ListItem disablePadding>
                  <ListItemButton
                     className={ "navItem"}
                      onClick={async () => {
                      try {
                        setLoading(true);
                        const response = await DownloadPortalGuideService(
                          loginUserType
                        );
                        const content = response.headers["content-type"];
                        download(response.data, "User Portal.pdf", content);
                      } catch (err) {
                        showNotification("Error", "Failed To Fetch");
                      } finally {
                        setLoading(false);
                      }
                    }}
                    color="primary">
                    <ListItemIcon sx={{ minWidth: "30px" }}>
                    <MenuBookIcon sx={{ color: "#003f93" }} />
                    </ListItemIcon>
                    <ListItemText
                      className="sideNavList"
                      primary="Portal Guide"
                    />
                  </ListItemButton>
                </ListItem>
                {!auth?.ldapParam?.rilUser ?
                <ListItem disablePadding>
                  <ListItemButton
                    selected={activeURL === "/resetPassword" ? true : false}
                    className={
                      activeURL === "/resetPassword" ? "active" : "navItem"
                    }
                   onClick={() => { onForgotPasswordClick();
                     navigate('/resetPassword', { state: { from: location } }) }}
                   >
                    <ListItemIcon sx={{ minWidth: "30px" }}>
                    <NoEncryptionGmailerrorredIcon sx={{ color: "#003f93" }} />
                     </ListItemIcon>
                    <ListItemText
                      className="sideNavList"
                      primary="Forget Password"
                    />
                  </ListItemButton>
                </ListItem>
            : ''
          }
            </List>
          </Box>
        </Box>
      </Drawer>
    </div>
  );
};

export default SideNav;
